export default "__VITE_ASSET__DpTa8KYZ__"